import { useDrawer } from '../../cdl/Drawer/useDrawer.hook';
import { IconButton } from '../../cdl/IconButton/IconButton';
import { AgentImportedLabel } from '../../common/AgentImportedLabel/AgentImportedLabel';
import { translate } from '../../common/helpers/translate.helper';
import { IconPencil } from '../../common/icons/cdl/Pencil';
import { Box } from '../../common/ui/Box';

import { UpdateAgentForm } from '../UpdateAgentForm';
import { useAgentStateChange } from '../useAgentStateChange';
import { ArchiveAgentPopupButton } from './ArchiveAgentPopupButton';

export const ActiveActions = ({ agent }) => {
    const agentStateChangeMutation = useAgentStateChange();
    const { push, pop } = useDrawer();

    const openEditModal = (agent) => {
        const drawerId = push({
            header: { title: translate('agents.editAgent') },
            content: <UpdateAgentForm agentId={agent.id} onSuccess={() => pop(drawerId)} />,
        });
    };

    const onAgentArchive = (agent) => {
        const agentToArchive = {
            ...agent,
            active: false,
        };
        agentStateChangeMutation.mutate({
            agentId: agentToArchive.id,
            agent: agentToArchive,
        });
    };

    return agent.source ? (
        <AgentImportedLabel />
    ) : (
        <Box display="flex" flexDirection="row" flexWrap="nowrap">
            <IconButton
                Icon={IconPencil}
                onClick={(e) => {
                    openEditModal(agent);
                    e.stopPropagation();
                }}
                tooltipLabel={translate('agents.editAgent')}
            />
            <ArchiveAgentPopupButton onConfirm={() => onAgentArchive(agent)} name={agent.name} />
        </Box>
    );
};
